module.exports = __webpack_public_path__ + "img/slide-21.b4a6bd7a.jpeg";